import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import colors from "styles/colors"
import dimensions from "styles/dimensions"

const HeaderContainer = styled("div")`
  height: 100px;
  position: fixed;
  top: 34px;
  max-width: 1600px;
  z-index: 3;
  width: calc(100% - 96px);

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
    width: 100%;
    top: 0;
  }
`

const HeaderContent = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1600px;
  line-height: 12px;
  margin: auto;

  & .logo {
    color: currentColor;
    text-decoration: none;
    font-size: 32px;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    line-height: normal;
  }
`

const HeaderLinks = styled("div")`
  display: flex;
  justify-content: end;
  width: 100%;
  padding-left: ${dimensions.pagePaddingTop}px;
  max-width: 400px;

  @media (max-width: 768px) {
    justify-content: end;
    padding-left: 0px;
  }

  a {
    color: currentColor;
    text-decoration: none;
    font-weight: 500;
    letter-spacing: 0.03em;
    font-size: 20px;
    text-transform: uppercase;
    line-height: 120%;

    border-bottom: 3px solid transparent;
    padding: 0;
    margin-right: 64px;
    display: block;
    position: relative;

    @media (max-width: 768px) {
      font-size: 18px;
      margin-right: 38px;
    }

    &:last-child {
      margin: 0;
    }

    &:after {
      position: absolute;
      content: "";
      width: 100%;
      height: 3px;
      background: transparent;
      top: 24px;
      right: 0%;
      transition: 100ms ease-in-out background;
      visibility: hidden;
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
      transition: all 0.3s ease-in-out 0s;
    }

    &:hover {
      &:after {
        background: ${colors.grey900};
        visibility: visible;
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
      }
    }

    &.Link--is-active {
      &:after {
        background: ${colors.grey900};
        visibility: visible;
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
        transition: all 0.3s ease-in-out 0s;
      }
    }
  }
`

const Header = () => (
  <HeaderContainer>
    <HeaderContent>
      <Link className="logo" to="/">
        Johannes Schön
      </Link>
      <HeaderLinks>
        <Link activeClassName="Link--is-active" to="/work">
          Viewing Room
        </Link>
        <Link activeClassName="Link--is-active" to="/contact">
          Contact
        </Link>
      </HeaderLinks>
    </HeaderContent>
  </HeaderContainer>
)

export default Header
